/**
 * Upload Page
 * Page component for invoice upload functionality
 */

import React from 'react';
import { InvoiceUpload } from '../components/invoice/InvoiceUpload';

export const UploadPage: React.FC = () => {
  return (
    <div>
      <InvoiceUpload />
    </div>
  );
};

UploadPage.displayName = 'UploadPage';
